import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class EnvironmentalCondition {
    constructor(doc)
    {
		this.label = null
		this.distanceFromPropertyLinearMeasure = null
		this.environmentalConditionIdentifiedDescription = null
		this.environmentalConditionProximityType = null
		this.environmentalConditionType = null
		this.environmentalConditionTypeOtherDescription = null
		this.valueMarketabilityImpactType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.distanceFromPropertyLinearMeasure = x.getMISMOMeasureElement(doc, "./ns:DistanceFromPropertyLinearMeasure");
		this.environmentalConditionIdentifiedDescription = x.getStringElement(doc, "./ns:EnvironmentalConditionIdentifiedDescription");
		this.environmentalConditionProximityType = x.getStringElement(doc, "./ns:EnvironmentalConditionProximityType");
		this.environmentalConditionType = x.getStringElement(doc, "./ns:EnvironmentalConditionType");
		this.environmentalConditionTypeOtherDescription = x.getStringElement(doc, "./ns:EnvironmentalConditionTypeOtherDescription");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }

	GetConditionType() {
		return h.descriptionOrOther(this.environmentalConditionType, this.environmentalConditionTypeOtherDescription);
	}

	GetProximity() {
		var prox = this.environmentalConditionProximityType;
		var measure = this.distanceFromPropertyLinearMeasure.ToString();
		prox = h.addWithSpacer(prox, measure);
		return prox;
	}

}

